import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown, Button } from 'react-bootstrap';

import LinkContainer from '../../containers/LinkContainer';

const ButtonUpgrade = ({ isMenuItem, eventKey }) => {
  if (isMenuItem) {
    return (
      <LinkContainer to="/upgrade">
        <Dropdown.Item eventKey={eventKey}> Upgrade Plan</Dropdown.Item>
      </LinkContainer>
    );
  }
  return (
    <LinkContainer to="/upgrade">
      <Button variant="primary"> Upgrade Plan</Button>
    </LinkContainer>
  );
};
ButtonUpgrade.defaultProps = {
  isMenuItem: false,
  eventKey: 0
};
ButtonUpgrade.propTypes = {
  isMenuItem: PropTypes.number,
  eventKey: PropTypes.number
};
export default ButtonUpgrade;
